import { useEffect } from 'react';

const SECTIONS = ['hero', 'about', 'skills', 'projects', 'experiences', 'contact'];
const VISIBILITY_THRESHOLD = 0.3; // 30% della sezione visibile

function getSessionId(): string {
  return sessionStorage.getItem('tracking_session_id') ?? '';
}

/**
 * Traccia quali sezioni del portfolio l'utente ha visitato tramite IntersectionObserver.
 * Invia una visita con page="/#sectionId" la prima volta che ogni sezione diventa visibile.
 */
export function useSectionTracking() {
  useEffect(() => {
    const sessionId = getSessionId();
    if (!sessionId) return;

    const seen = new Set<string>();

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const id = entry.target.id;
          if (entry.isIntersecting && !seen.has(id)) {
            seen.add(id);
            fetch('/api/track/visit', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                sessionId,
                page: `/#${id}`,
              }),
            }).catch(() => {});
          }
        }
      },
      { threshold: VISIBILITY_THRESHOLD }
    );

    for (const id of SECTIONS) {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    }

    return () => observer.disconnect();
  }, []);
}
